// frontend/src/pages/AdvancedSearchPage.js (Corrected)
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import apiClient from '../api';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { formatDate } from '../utils/formatDate';

function AdvancedSearchPage() {
  const [results, setResults] = useState([]);
  const [filters, setFilters] = useState({
    first_name: '',
    last_name: '',
    gender: '',
    offense_type: '',
    location: '',
    primary_officer_id: '',
  });
  const [arrestDateStart, setArrestDateStart] = useState(null);
  const [arrestDateEnd, setArrestDateEnd] = useState(null);
  const [staffUsers, setStaffUsers] = useState([]);

  useEffect(() => {
    const fetchUsers = async () => {
        try {
            const res = await apiClient.get('/api/users');
            setStaffUsers(res.data);
        } catch (err) { console.error("Failed to fetch users", err); }
    };
    fetchUsers();
  }, []);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
  };

  // frontend/src/pages/AdvancedSearchPage.js

const handleSearch = async (e) => {
    e.preventDefault();
    try {
        // Create a copy of filters but remove any empty values
        const activeFilters = { ...filters };
        Object.keys(activeFilters).forEach(key => {
            if (activeFilters[key] === '' || activeFilters[key] === null) {
                delete activeFilters[key];
            }
        });

        // Add formatted dates if they exist
        if (arrestDateStart) {
            activeFilters.arrestDateStart = arrestDateStart.toISOString().split('T')[0];
        }
        if (arrestDateEnd) {
            activeFilters.arrestDateEnd = arrestDateEnd.toISOString().split('T')[0];
        }
        
        // Make a GET request with the filters as parameters
        const response = await apiClient.get('/api/juveniles', { params: activeFilters });
        
        // The data is directly in response.data.juveniles
        setResults(response.data.juveniles);

    } catch (err) {
        console.error("Advanced search failed", err);
    }
};

  return (
    <div className="card">
      <h1 className="text-2xl font-bold text-slate-800 mb-4">Advanced Search</h1>
      <form onSubmit={handleSearch} className="mb-8 p-4 bg-slate-50 rounded-lg grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 items-end">
        {/* Row 1 */}
        <div className="md:col-span-1">
          <label className="block text-sm font-medium text-slate-700 mb-1">First Name</label>
          <input type="text" name="first_name" placeholder="e.g., Jane" value={filters.first_name} onChange={handleFilterChange} />
        </div>
        <div className="md:col-span-1">
          <label className="block text-sm font-medium text-slate-700 mb-1">Last Name</label>
          <input type="text" name="last_name" placeholder="e.g., Smith" value={filters.last_name} onChange={handleFilterChange} />
        </div>
        <div className="md:col-span-1">
          <label className="block text-sm font-medium text-slate-700 mb-1">Gender</label>
          <select name="gender" value={filters.gender} onChange={handleFilterChange}>
            <option value="">-- Any Gender --</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Other">Other</option>
          </select>
        </div>
        {/* Row 2 */}
        <div className="md:col-span-1">
          <label className="block text-sm font-medium text-slate-700 mb-1">Offense Type</label>
          <input type="text" name="offense_type" placeholder="e.g., Theft" value={filters.offense_type} onChange={handleFilterChange} />
        </div>
        <div className="md:col-span-1">
          <label className="block text-sm font-medium text-slate-700 mb-1">Location</label>
          <input type="text" name="location" placeholder="e.g., St. George's" value={filters.location} onChange={handleFilterChange} />
        </div>
        <div className="md:col-span-1">
          <label className="block text-sm font-medium text-slate-700 mb-1">Primary Officer</label>
          <select name="primary_officer_id" value={filters.primary_officer_id} onChange={handleFilterChange}>
            <option value="">-- Any Officer --</option>
            {staffUsers.map(user => (
              <option key={user.id} value={user.id}>{user.full_name}</option>
            ))}
          </select>
        </div>
        {/* Row 3 - Dates */}
        <div className="md:col-span-1">
            <label className="block text-sm font-medium text-slate-700 mb-1">Arrest Date From</label>
            <DatePicker selected={arrestDateStart} onChange={date => setArrestDateStart(date)} dateFormat="dd/MM/yyyy" placeholderText="dd/MM/yyyy" className="w-full" />
        </div>
        <div className="md:col-span-1">
            <label className="block text-sm font-medium text-slate-700 mb-1">Arrest Date To</label>
            <DatePicker selected={arrestDateEnd} onChange={date => setArrestDateEnd(date)} dateFormat="dd/MM/yyyy" placeholderText="dd/MM/yyyy" className="w-full" />
        </div>
        <button type="submit" className="bg-gold text-white hover:bg-gold-dark font-bold py-2 px-4 rounded-lg self-end">Search</button>
      </form>

      <h2 className="text-xl font-bold text-slate-800">Search Results ({results.length})</h2>
        <div className="overflow-x-auto mt-4">
            <table className="w-full text-left">
                <thead className="bg-slate-50 border-b-2 border-slate-200">
                  <tr>
                    <th className="p-4 text-sm font-semibold text-slate-600 uppercase tracking-wider">
                      Name
                    </th>
                    <th className="p-4 text-sm font-semibold text-slate-600 uppercase tracking-wider">
                      Date of Birth
                    </th>
                    <th className="p-4 text-sm font-semibold text-slate-600 uppercase tracking-wider">
                      Primary Officer
                    </th>
                    <th className="p-4 text-sm font-semibold text-slate-600 uppercase tracking-wider">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                    {results.length > 0 ? (
                    results.map(juvenile => (
                        <tr key={juvenile.id} className="border-b hover:bg-slate-50">
                            <td className="p-4 font-medium text-slate-800">{juvenile.first_name} {juvenile.last_name}</td>
                            <td className="p-4 text-slate-600">{formatDate(juvenile.date_of_birth)}</td>
                            <td className="p-4 text-slate-600">{juvenile.primary_officer_name || 'N/A'}</td>
                            <td className="p-4">
                                <Link to={`/juveniles/${juvenile.id}`} className="bg-gold text-white hover:bg-gold-dark font-bold py-1 px-3 rounded-lg text-sm">
                                View Profile
                                </Link>
                            </td>
                        </tr>
                    ))
                    ) : (
                    <tr>
                        <td colSpan="4" className="p-4 text-center text-slate-500">No results found. Please adjust your filters and try again.</td>
                    </tr>
                    )}
                </tbody>
            </table>
        </div>
    </div>
  );
}

export default AdvancedSearchPage;
